<template>
  <div class="terms" style="background-image: linear-gradient(to bottom right, #002f64, #1CB5E0)">
    <div class="terms__container">
        <h1 class="terms__container--title">
            Privacy Policy
        </h1>
        <div class="terms__container--text">

            <p>The Hike On Earth team provides this privacy notice in an effort to better protect your privacy and help you know your data protection rights. This page explains how we use the personal data we collect from you when you visit our website.</p>


            <h2>
                Topics
            </h2>
            <ul>

                <li v-for="i in menu" :key="i.target" class="terms__li--menu" @click="scrollTarget(i.target)">{{i.text}}</li>
                <!-- <li class="terms__li--menu" data-target="data-how-collect">How do we collect data ?</li>
                <li class="terms__li--menu" data-target="data-how-use">How will we use your data ?</li>
                <li class="terms__li--menu" data-target="data-how-store">How do we store your data ?</li>
                <li class="terms__li--menu" data-target="marketing">Marketing</li>
                <li class="terms__li--menu" data-target="data-protection-rights">What are your data protection rights ?</li>
                <li class="terms__li--menu" data-target="data-cookies">How to manage your cookies ?</li>
                <li class="terms__li--menu" data-target="data-other-websites">Privacy policies of other websites</li>
                <li class="terms__li--menu" data-target="change-policy">Changes to our privacy policy</li>
                <li class="terms__li--menu" data-target="how-contact-us">How to contact us ?</li>
                <li class="terms__li--menu" data-target="how-contact-authorities">How to contact the appropriate authorities ?</li> -->
            </ul>
            <section class="terms__section" id="data-what-collect">
                <h2>
                    What data do we collect ?
                </h2>
                <h4>
                    Data and content you directly provide:
                </h4>
                <p>
                    You provide this data when you create or update your account or public profile, add contents in one of the forms on the website or place an order for any of our products or services. It is composed of:
                </p>
                <ul class="u-margin-bottom-small">
                    <li class="terms__li--bar">Personal identification information: your email address, first name, last name, and profile pictures.</li>
                    <li class="terms__li--bar">Information you provide on your Hike On Earth profile page: your nationality, languages, age, pseudonym, past and intended hikes and social media accounts.</li>
                    <li class="terms__li--bar">Content you share during your activity on the Hike On Earth website: uploaded pictures, sent and received messages, saved trails, hiking partner requests, any data added into the trail or feedback pages.</li>
                    <li class="terms__li--bar">Data collected during your activity on our store: your address and contact details if you have placed an order, the products you purchased and the date of order. Hike On Earth does not collect any financial information. Online payments are processed through a secure platform called Stripe. To check how Stripe processes and protects your financial information, visit this page: <a href="https://stripe.com/en-be/privacy" class="btn__text">https://stripe.com/en-be/privacy</a>.</li>
                    <li class="terms__li--bar">Labels and figures directly based on your activity: we label you as a “contributor” as soon as you add new trails or trail details. We also attribute you contribution points depending on the amount of trail details you add. </li>
                </ul>
                <h4>
                    Cookies
                </h4>
                <p>
                Cookies are text files placed on your computer to collect standard Internet log information and visitor behavior information. When you visit our websites, we may collect information from you automatically through cookies or similar technology.
                </p>
                <p>
                There are a number of different types of cookies, however, our website uses:
                </p>
                <ul>
                    <li class="terms__li--bar">Functionality – Hike On Earth uses these cookies so that we recognize you on our website and remember your previously selected preferences. These could include what language you prefer and location you are in. A mix of first-party and third-party cookies are used.</li>
                    <li class="terms__li--bar">Advertising – Hike On Earth uses these cookies to collect information about your visit to our website, the content you viewed, the links you followed and information about your browser, device, and your IP address. Our Company sometimes shares some limited aspects of this data with third parties for advertising purposes. We may also share online data collected through cookies with our advertising partners. This means that when you visit another website, you may be shown advertising based on your browsing patterns on our website.</li>
                </ul>

            </section>
            <section class="terms__section" id="data-how-collect">
                <h2>
                    How do we collect data ?
                </h2>
                <p>
                You directly provide Hike On Earth with most of the data it collects. This data is collected when you: 
                </p>
                <ul>
                    <li class="terms__li--bar">Register or place an order for any of our products or services</li>
                    <li class="terms__li--bar">Update your account details or the contents of your profile page</li>
                    <li class="terms__li--bar">Fill-in a form on the website (feedback form, trail details, hiking partner request, …)</li>
                    <li class="terms__li--bar">Chat with other hikers or create of hiking partner request</li>
                    <li class="terms__li--bar">Use or view our website via your browser’s cookies.</li>
                </ul>
            </section>
            <section class="terms__section" id="data-how-use">
                <h2>
                  How will we use your data ?
                </h2>
                <p>
                 Hike On Earth collects your data so that we can:
                </p>
                <ul>
                    <li class="terms__li--bar">Help you connect with other hikers by enabling them to view your profile, send you messages and add you on third-party social networks.</li>
                    <li class="terms__li--bar">Email you with information on contents added to the website and general news from the hiking community (for example: new trails, public events related to hiking).</li>
                    <li class="terms__li--bar">Email you with information on our products and services we think you might like.</li>
                    <li class="terms__li--bar">Improve your experience on our website by keeping you signed in and adapting the layout and language of the pages you visit.</li>
                </ul>
            </section>
            <section class="terms__section" id="data-how-store">
                <h2>
                How do we store your data ?
                </h2>
            </section>
            <section class="terms__section" id="marketing">
                <h2>
                Marketing
                </h2>
                <p>Hike On Earth would like to send you information about products and services of ours that we think you might like, as well as those of our partner companies.</p>
                <p>If you have agreed to receive marketing, you may always opt out at a later date.</p>
                <p>You have the right at any time to stop Hike On Earth from contacting you for marketing purposes.</p>
            </section>
            <section class="terms__section" id="data-protection-rights">
                <h2>
                    What are your data protection rights ?
                </h2>
                <p>
                        We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
                </p>
                <ul class="u-margin-bottom-small">
                    <li>
                        <span class="terms__li--span">The right to access</span> – You have the right to request Hike On Earth for copies of your personal data. We may charge you a small fee for this service.
                    </li>
                    <li>
                        <span class="terms__li--span">The right to rectification</span> – You have the right to request that Hike On Earth correct any information you believe is inaccurate. You also have the right to request Hike On Earth to complete the information you believe is incomplete.
                    </li>
                    <li>
                        <span class="terms__li--span">The right to erasure</span> – You have the right to request that Hike On Earth erase your personal data, under certain conditions.
                    </li>
                    <li>
                        <span class="terms__li--span">The right to restrict processing</span> – You have the right to request that Hike On Earth restrict the processing of your personal data, under certain conditions.
                    </li>
                    <li>
                        <span class="terms__li--span">The right to object to processing</span> – You have the right to object to Hike On Earth’s processing of your personal data, under certain conditions.
                    </li>
                    <li>
                        <span class="terms__li--span">The right to data portability</span> – You have the right to request that Hike On Earth transfer the data that we have collected to another organization, or directly to you, under certain conditions.
                    </li>
                </ul>
                <p>
                If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us at our email:
                </p>
                <ul>
                    <li><span>Call us at:</span> <a href="tel:0032497331008" class="btn__text">+32 497 33 10 08</a>
</li>
                    <li><span>Or write to us:</span> <a href="mailto:info@hikeonearth.com" class="btn__text">info@hikeonearth.com</a>
</li>
                </ul>
                        
            </section>
            <section class="terms__section" id="data-cookies">
                <h2>
                How to manage your cookies ?
                </h2>
                <p>
                You can set your browser not to accept cookies, and the above website tells you how to remove cookies from your browser. However, in a few cases, some of our website features may not function as a result.                </p>
            </section>
            <section class="terms__section" id="data-other-website">
                <h2>
                Privacy policies of other websites
                </h2>
                <p>
                The Hike On Earth website contains links to other websites. Our privacy policy applies only to our website, so if you click on a link to another website, you should read their privacy policy.
                </p>
            </section>
            <section class="terms__section" id="change-policy">
                <h2>
                Changes to our privacy policy
                </h2>
                <p>
                Hike On Earth keeps its privacy policy under regular review and places any updates on this web page. This privacy policy was last updated on 16 April 2019.
                </p>
            </section>
            <section class="terms__section" id="how-contact-us">
                <h2>
                How to contact us ?
                </h2>
                <p>
                    If you have any questions about Hike On Earth’s privacy policy, the data we hold on you, or you would like to exercise one of your data protection rights, please do not hesitate to contact us.
                </p>
                <ul>
                    <li>
                        <span>Email us at:</span>  <a href="mailto:info@hikeonearth.com" class="btn__text">info@hikeonearth.com</a>
                    </li>
                    <li>
                    <span>Call us at:</span>  <a href="tel:0032497331008" class="btn__text">+32 497 33 10 08</a>
                    </li>
                    <li>
                        <span>Or write to us at:</span>  1384A, Chaussée de Waterloo - 1180 Uccle - BELGIUM
                    </li>
    
                </ul>
            </section>
            <section class="terms__section" id="how-contact-authorities">
                <h2>
                    How to contact the appropriate authorities ?
                </h2>
                <p>
                    Should you wish to report a complaint or if you feel that Hike On Earth has not addressed your concern in a satisfactory manner, you may contact the Information Commissioner’s Office.
                </p>
                <ul>
                    <li>
                        <span>Email:</span>  <a href="mailto:commission@privacycommission.be" class="btn__text">commission@privacycommission.be</a>
                    </li>
                    <li>
                    <span>Address:</span>  35 rue de la Presse,  1000 Brussels, Belgium
                    </li>
                    <li>
                        <span>Phone:</span>   <a href="tel:003222744800" class="btn__text">+32 2 274 48 00</a>
                    </li>
                    <li>
                    <span>Website:</span>  <a href="http://www.privacycommission.be/" class="btn__text">http://www.privacycommission.be/</a>
                    </li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
import scrollTo from '../composables/scroll';

export default {

  setup(){

    const menu =                [
              { target: "data-what-collect", text:"What data do we collect ?"},
               { target: "data-how-collect", text:"How do we collect data ?"},
               { target: "data-how-use", text:"How will we use your data ?"},
               { target: "data-how-store", text:"How do we store your data ?"},
               { target: "marketing", text:"Marketing"},
               { target: "data-protection-rights", text:"What are your data protection rights ?"},
               { target: "data-cookies", text:"How to manage your cookies ?"},
               { target: "data-other-websites", text:"Privacy policies of other websites"},
               { target: "change-policy", text:"Changes to our privacy policy"},
               { target: "how-contact-us", text:"How to contact us ?"},
               { target: "how-contact-authorities", text:"How to contact the appropriate authorities ?"},
    ];

    const scrollTarget = (target) => {
      console.log(target);
      scrollTo(target);
    }
    return {menu, scrollTarget}
  }

}
</script>

<style lang="scss" scoped>

@import '../style/main';
@import '../style/page/terms';


</style>